import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { Stepper } from 'components/stepper'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <Stepper />
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font-sans-serif);
  font-size: 16px;
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--site-background);
`
export default MainComponent
